// extracted by mini-css-extract-plugin
export default {"store":"ConfirmStores_store__F+Jdx","terminalName":"ConfirmStores_terminalName__Og2nR","terminalNo":"ConfirmStores_terminalNo__LbiH+"};